import { render, staticRenderFns } from "./HouseConnectionOrderProductSummary.vue?vue&type=template&id=12a8b425&scoped=true&"
import script from "./HouseConnectionOrderProductSummary.vue?vue&type=script&lang=js&"
export * from "./HouseConnectionOrderProductSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8b425",
  null
  
)

export default component.exports